// Recovered compiled webpack factory 88722. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, {
    E1: () => d,
    Ef: () => o,
    Fy: () => _,
    JD: () => s,
    Lc: () => h,
    Le: () => f,
    Sn: () => u,
    fs: () => l,
    i_: () => n,
    jG: () => p,
    sy: () => a,
    uT: () => i,
    xc: () => c,
  });
  let n = "sentry.source",
    a = "sentry.sample_rate",
    o = "sentry.previous_trace_sample_rate",
    i = "sentry.op",
    s = "sentry.origin",
    l = "sentry.idle_span_finish_reason",
    u = "sentry.measurement_unit",
    c = "sentry.measurement_value",
    f = "sentry.custom_span_name",
    d = "sentry.profile_id",
    p = "sentry.exclusive_time",
    h = "sentry.link.type",
    _ = "gen_ai.conversation.id";
}
